
<template>

	<div class="main-container">

		<b-row>

			<b-col><b-form-input class="mb-2" placeholder="Поиск" v-model="attr_search" v-on:input="update_attrs_visible"/></b-col>

		</b-row>

		<biTable class="main-container_content" :data="new_attrs_visible">
			<template v-slot:value_params="row">
				<template v-if="row.data.value.attr_key == 'attrs.KeyParameters.KeyParameter' || row.data.value.attr_key == 'attrs.SubConstructions.SubConstruction.KeyParameter'">

					<div v-if="row.data.value.value.Value == null">

						<div v-for="( elem, index ) in row.data.value.value" :key="index">

							{{ format_key_parameter(elem) }}

						</div>

					</div>

					<div v-else>

						{{ format_key_parameter(row.data.value.value) }}

					</div>
				</template>
			</template>
		</biTable>

	</div>

</template>

<script>

import api from "../../../../api"
import biTable from "../../../widgets/bi-table"

export default
{
	props :
	{
		data : Object,
		attrs : Array,
		key_parameter_type_reference : { type : Object, default : () => {} },
		reference : { type : Boolean, default : () => false },
		appendToBody : { type : Boolean, default : () => true },
		reference_attrs : { type : Array, default : () => [] },
	},

	components :
	{
		biTable,
	},

	data()
	{
		return {

			prepared_data : [],
			attrs_visible : [],
			attr_search : null,
			attr_keys_with_value : [],

			important_keys_for_reference : [ "attrs.Area", "attrs.cost", "attrs.UPKS" ],

			new_attrs_visible: [],

		}
	},

	filters :
	{
		round2(value)
		{
			return api.round2(value)
		}
	},

	watch :
	{
		data :
		{
			immediate : true,

			handler(data)
			{
				this.update(data, null)
			}
		},

		attrs :
		{
			immediate : true,

			handler(attrs)
			{
				this.update(null, attrs)
			}
		},
	},

	methods :
	{
		update(data, attrs)
		{
			if(data == null)
				data = this.$props.data

			if(attrs == null)
				attrs = this.$props.attrs

			if(data == null || attrs == null)
				return

			this.prepared_data = api.deep_clone(data)
			this.attr_keys_with_value = []

			var arrays =
			[
				{ attrs : this.prepared_data.SubParcels, key : "SubParcel" },
				{ attrs : this.prepared_data.SubBuildings, key : "SubBuilding" },
				{ attrs : this.prepared_data.SubFlats, key : "SubFlat" },
				{ attrs : this.prepared_data.SubConstructions, key : "SubConstruction" },
				{ attrs : this.prepared_data.ZonesAndTerritories, key : "ZoneAndTerritory" }
			]

			if(this.prepared_data.PositionInObject_)
				arrays.push({ attrs : this.prepared_data.PositionInObject_.Levels, key : "Level" })

			arrays.forEach(
				elem =>
				{
					try
					{
						elem.attrs[elem.key] = api.prepare_array_of_objects_for_table(elem.attrs, elem.key)
					}
					// eslint-disable-next-line
					catch {}
				})

			attrs.forEach(
				attr =>
				{
					if(this.get_raw_value_from_data(this.prepared_data, attr.key) != null || ( this.reference && this.important_keys_for_reference.includes(attr.key) ))
						this.attr_keys_with_value.push(attr.key)
				})

			this.update_attrs_visible(null, null, attrs)
		},

		update_attrs_visible(attr_search = null, attrs = null)
		{
			var exp

			if(attr_search == null)
				attr_search = this.attr_search

			if(attrs == null)
				attrs = this.attrs

			if(attr_search)
				exp = new RegExp(attr_search, "i")

			// 3229, пункт 11
			// this.reference_attrs.findIndex(attr_ref => attr_ref.key == attr.key) >= 0
			// ||

			this.attrs_visible = attrs.filter(
				attr =>
					(
						this.reference
						&&
						this.important_keys_for_reference.includes(attr.key)
					)
					||
					(
						this.attr_keys_with_value.findIndex(key => key == attr.key) >= 0
						&&
						( attr_search == null || attr.name.match(exp) )
					)
				)

			this.new_attrs_visible = this.attrs_visible.map(attr => {
				let row = { title: attr.name, }
				let value = this.get_raw_value_from_data(this.prepared_data, attr.key)

				if (attr.key == 'attrs.coinvest_cost') row.value = `${ value } ${ this.format_coinvest_cost_per_unit(this.prepared_data) }`
				else if (attr.key  == 'attrs.cost' || attr.key  == 'attrs.UPKS') row.value = value | this.round2
				else if (attr.key  == 'attrs.KeyParameters.KeyParameter' || attr.key  == 'attrs.SubConstructions.SubConstruction.KeyParameter')
				{
					value = { attr_key: attr.key, value }
					row.params = true
				}
				else value = this.format_value(value, attr.type, attr.reference)

				row.value = value

				return row
			})
		},

		format_reference(ref, value)
		{
			return api.format_reference(ref, value)
		},

		format_coinvest_cost_per_unit(data)
		{
			return api.format_coinvest_cost_per_unit(data)
		},

		format_key_parameter(elem)
		{
			return api.format_key_parameter(elem, this.key_parameter_type_reference)
		},

		format_value_from_data(data, key, value_type, reference = null)
		{
			return api.format_value_from_data(data, key, value_type, reference)
		},
		
		format_value(value, value_type, reference)
		{
			return api.format_value(value, value_type, reference)
		},

		get_raw_value_from_data(data, key)
		{
			return api.get_obj_value({ attrs : data }, key)
		},
	}
}

</script>

<style>

.name
{
}

.value
{
	min-width: 200px !important;
}

</style>

